import logo from "../static/images/logo.svg"

const Logo = () => (
  <img src={logo}
  style={{ height: 65, width: 65 }}
              alt="website logo"
            />
)
export default Logo
